/* Banner de cookies sobre la Customer Privacy API de Shopify. Si la API no responde
   en 3 s no se muestra nada: nunca bloquea la tienda. [data-cookie-open] lo vuelve a abrir.
   shortcut: solo aceptar/rechazar todo; añadir panel por categoría si legal lo pide. */
(() => {
  const banner = document.querySelector('[data-cookie-banner]');
  if (!banner || !window.Shopify?.loadFeatures) return;
  let api = null;
  let timedOut = false;
  const timer = setTimeout(() => { timedOut = true; }, 3000);
  banner.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-consent]');
    if (!btn || !api) return;
    const yes = btn.dataset.consent === 'accept';
    api.setTrackingConsent({ analytics: yes, marketing: yes, preferences: yes, sale_of_data: yes }, () => { banner.hidden = true; });
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-cookie-open]') || !api) return;
    banner.hidden = false;
    banner.querySelector('[data-consent="accept"]')?.focus();
  });
  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => {
    clearTimeout(timer);
    if (err || !window.Shopify.customerPrivacy) return;
    api = window.Shopify.customerPrivacy;
    if (timedOut || !api.shouldShowBanner()) return;
    setTimeout(() => { banner.hidden = false; }, 600);
  });
})();
